import { createAsyncAction, createAction } from "typesafe-actions";
import { AlertNotification, Patient, PatientDetailedSensorData } from "@shared/models";
import {
  AlertNotificationFilter,
  PatientDailyChartFilter,
  PaginatedResponse,
  PatientDetailedChartFilter,
  PatientFilter,
  UpdateStatusShape,
  ImportResults,
  WithCallback,
} from "@shared/interfaces";
import { PatientVitalSignsCalculation } from "@shared/models/PatientVitalSignsCalculation";

import { PatientActionTypes } from "./constants";
import { CreatePatientDto, CreatePatientSuccess, GetPatientSuccess, ImportPatientsDto } from "../interfaces";

export const getPatients = createAsyncAction(
  PatientActionTypes.GET_PATIENTS,
  PatientActionTypes.GET_PATIENTS_SUCCESS,
  PatientActionTypes.GET_PATIENTS_FAILURE,
)<PatientFilter, PaginatedResponse<Patient>, Error>();

export const getPatient = createAsyncAction(
  PatientActionTypes.GET_PATIENT,
  PatientActionTypes.GET_PATIENT_SUCCESS,
  PatientActionTypes.GET_PATIENT_FAILURE,
)<{ id: number }, GetPatientSuccess, Error>();

export const getPatientDetailedSensorsData = createAsyncAction(
  PatientActionTypes.GET_PATIENT_DETAILED_SENSORS_DATA,
  PatientActionTypes.GET_PATIENT_DETAILED_SENSORS_DATA_SUCCESS,
  PatientActionTypes.GET_PATIENT_DETAILED_SENSORS_DATA_FAILURE,
)<PatientDetailedChartFilter, PaginatedResponse<PatientDetailedSensorData>, Error>();

export const getPatientSensorsAverageData = createAsyncAction(
  PatientActionTypes.GET_PATIENT_SENSORS_AVERAGE_DATA,
  PatientActionTypes.GET_PATIENT_SENSORS_AVERAGE_DATA_SUCCESS,
  PatientActionTypes.GET_PATIENT_SENSORS_AVERAGE_DATA_FAILURE,
)<PatientDailyChartFilter, PaginatedResponse<PatientVitalSignsCalculation>, Error>();

export const getPatientDailyAlertNotifications = createAsyncAction(
  PatientActionTypes.GET_PATIENT_DAILY_ALERT_NOTIFICATIONS,
  PatientActionTypes.GET_PATIENT_DAILY_ALERT_NOTIFICATIONS_SUCCESS,
  PatientActionTypes.GET_PATIENT_DAILY_ALERT_NOTIFICATIONS_FAILURE,
)<AlertNotificationFilter, PaginatedResponse<AlertNotification>, Error>();

export const createPatient = createAsyncAction(
  PatientActionTypes.CREATE_PATIENT,
  PatientActionTypes.CREATE_PATIENT_SUCCESS,
  PatientActionTypes.CREATE_PATIENT_FAILURE,
)<WithCallback<CreatePatientDto>, CreatePatientSuccess, Error>();

export const importPatients = createAsyncAction(
  PatientActionTypes.IMPORT_PATIENTS,
  PatientActionTypes.IMPORT_PATIENTS_SUCCESS,
  PatientActionTypes.IMPORT_PATIENTS_FAILURE,
)<ImportPatientsDto, ImportResults | null, Error>();

export const updatePatient = createAsyncAction(
  PatientActionTypes.UPDATE_PATIENT,
  PatientActionTypes.UPDATE_PATIENT_SUCCESS,
  PatientActionTypes.UPDATE_PATIENT_FAILURE,
)<WithCallback<CreatePatientDto & { id: number; reason: string }>, CreatePatientSuccess, Error>();

export const updatePatientStatus = createAsyncAction(
  PatientActionTypes.UPDATE_PATIENT_STATUS,
  PatientActionTypes.UPDATE_PATIENT_STATUS_SUCCESS,
  PatientActionTypes.UPDATE_PATIENT_STATUS_FAILURE,
)<UpdateStatusShape, CreatePatientSuccess, Error>();

export const setFilter = createAction(PatientActionTypes.SET_FILTER)<PatientFilter | null>();
export const updateFilter = createAction(PatientActionTypes.SET_FILTER)<Partial<PatientFilter>>();

export const setDetailedChartFilter = createAction(
  PatientActionTypes.SET_DETAILED_CHART_FILTER,
)<PatientDetailedChartFilter | null>();

export const setDailyChartFilter = createAction(
  PatientActionTypes.SET_DAILY_CHART_FILTER,
)<PatientDailyChartFilter | null>();

export const clearPatients = createAction(PatientActionTypes.CLEAR_PATIENTS)();
export const clearPatient = createAction(PatientActionTypes.CLEAR_PATIENT)();
